<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div v-show="!loading" class="welcome-page">
        <section class="welcome-block input-group-responsive text-center">
            <b-img center width="200" :src="require('../assets/img/branding/' + logoName)" alt="Only-One Generation est un réseau social dédié à la santé et les ainés par Only-One"></b-img>

            <div v-show="creationLoading" class="text-center">
                <div v-tr>Loading...|Chargement...</div>
                <b-spinner type="grow" variant="info"></b-spinner>
            </div>

            <b-card v-if="!creationLoading" id="registration-form" class="text-left">
                <h1 class="text-center" v-tr>Subscription|Inscription</h1>
                <b-form @submit.prevent="createAccount">
                    <b-form-group>
                        <label><span v-tr>Email|Courriel</span><span class="text-danger font-weight-bold pl-1">*</span></label>
                        <e-input @change="testEmailAvailability" ref="email" autocomplete="email" id="login-email" name="email" required v-model="newUser.email" type="email"
                                      :state="emailValid && emailAvailable"></e-input>
                        <b-form-invalid-feedback v-if="newUser.email === ''" id="login-email" v-tr>Email address required|Courriel requis</b-form-invalid-feedback>
                        <b-form-invalid-feedback v-else-if="!emailValid" id="login-email" v-tr>This email address is not valid|Ce courriel est incorrect</b-form-invalid-feedback>
                        <b-form-invalid-feedback v-else-if="!emailAvailable" id="login-email" v-tr>The email address is already taken|Ce courriel est déjà utilisé</b-form-invalid-feedback>
                    </b-form-group>

                    <b-row>
                        <b-col sm="12" md="6">
                            <b-form-group>
                                <label><span v-tr>Password|Mot de passe</span><span class="text-danger font-weight-bold pl-1">*</span></label>
                                <e-input ref="password" autocomplete="password" name="password" required v-model="newUser.password" :state="passwordValid" type="password"></e-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group>
                                <label><span v-tr>Confirmation|Confirmation</span><span class="text-danger font-weight-bold pl-1">*</span></label>
                                <e-input ref="confirm" name="confirm" required v-model="confirm" type="password" :state="passwordConfirmValid"></e-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <div class="invalid-feedback d-block" v-if="!passwordValid" style="margin: -13px 0 10px;">
                        <span v-tr>Your password must have at least 8 characters, a number and an uppercase letter|Votre mot de passe doit avoir au moins 8 caractères, un chiffre et une lettre majuscule.</span>
                    </div>
                    <b-row>
                        <b-col sm="12" md="6">
                            <b-form-group>
                                <label><span v-tr>First name|Prénom</span></label>
                                <e-input ref="firstname" :state="firstNameValid" autocomplete="fname" name="firstname" v-model="newUser.first_name" type="name"></e-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group>
                                <label><span v-tr>Last name|Nom</span></label>
                                <e-input ref="lastname" :state="lastNameValid" autocomplete="lname" name="name" v-model="newUser.last_name" type="name"></e-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="6">
                            <b-form-group>
                                <label><span v-tr>Gender|Genre</span></label>
                                <b-form-select v-model="newUser.gender">
                                    <option value="" v-tr>Non specified|Non spécifié</option>
                                    <option value="male" v-tr>Man|Homme</option>
                                    <option value="female" v-tr>Woman|Femme</option>
                                    <option value="other" v-tr>Other|Autre</option>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group>
                                <label><span v-tr>Postal Code|Code postal</span></label>
                                <e-input v-model="newUser.postal_code" type="postal-code" maxlength="10"></e-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <h5 class="error-msg">{{ error_msg }}</h5>
                    <p class="text-left mt-3" style="opacity: 0.8; font-weight: 500; font-size: 9pt;">
                        <span v-tr>By clicking Become Member, you accept the |En cliquant sur Devenir membre, vous acceptez les </span>
                        <a href="https://login.eyein.media/terms/termsofuse.php?lang=EN&standalone=true" target="_blank" class="text-underline" v-tr>terms and conditions|termes et conditions</a>
                        <span v-tr> and you agree to receive important announcements about Eye-In Wireless.| ainsi que de recevoir les communications importantes d'Eye-In Wireless.</span>
                    </p>

                    <a @click="changeLanguage()" href="#" class="basic-link float-left text-info text-underline ml-3 f-500" v-tr>Français|English</a>
                    <b-btn @click="createAccount" class="float-right" variant="primary" :disabled="!formValid" v-tr>Become Member|Devenir membre</b-btn>
                </b-form>

                <div class="clearfix"></div>
                <div v-if="isFromWifi" class="text-center mt-4">
                    <b-btn @click="window.history.back()" variant="outline-primary">
                        <i class="fas fa-chevron-left mr-1"></i>
                        <span v-tr>Back to the login page|Retour à la page de connexion</span>
                    </b-btn>
                </div>
            </b-card>
        </section>
    </div>
</template>

<script>
    import Network from "../../vue-components/helpers/Network";
    import {changeLanguage} from "../../vue-components/helpers/i18n";
    import Validation from "../../vue-components/helpers/Validation";

    export default {
        name: `register`,
        data() {
            return {
                Validation: Validation,
                newUser: null,
                newUserDefault: {
                    email: ``,
                    password: ``,
                    first_name: ``,
                    last_name: ``,
                    birth_date: null,
                    language: ``,
                    gender: ``,
                    postal_code: ``,
                    country: ``,
                    notification_enabled: true,
                    phone_number: ``
                },
                stores: [],
                emailAvailable: true,
                confirm: ``,
                loading: false,
                creationLoading: false,
                error_msg: ``,
                familyCode: null
            }
        },
        created() {
            this.newUser = clone(this.newUserDefault);
        },
        activated() {
            this.loading = false;
            this.$emit(`login-start`);

            this.confirm = ``;
            this.error_msg = ``;

            this.familyCode = this.$route.params.family_code;

            for (let key in this.newUser)
                this.newUser[key] = this.newUserDefault[key];

            this.newUser.email = this.$route.params.email;
        },
        computed: {
            emailValid() {
                return Validation.testEmail(this.newUser.email);
            },
            passwordValid() {
                return Validation.testPassword(this.newUser.password, false);
            },
            passwordConfirmValid() {
                if (!this.confirm) {
                    return null;
                } else {
                    return this.passwordValid && this.newUser.password === this.confirm;
                }
            },
            firstNameValid() {
                return Validation.testName(this.newUser.first_name, false);
            },
            lastNameValid() {
                return Validation.testName(this.newUser.last_name, false);
            },
            years() {
                let date = new Date().getFullYear();
                let arr = [];
                for (let i = date - 100; i <= date - 15; i++)
                    arr.unshift(i);
                return arr;
            },
            formValid() {
                return this.emailValid && this.emailAvailable && this.passwordValid && this.passwordConfirmValid && this.firstNameValid && this.lastNameValid;
            }
        },
        methods: {
            goToLogin() {
                this.$router.push(`/login`);
            },
            changeLanguage() {
                changeLanguage();
                this.$forceUpdate();
            },
            login() {
                if (this.familyCode)
                    localStorage.setItem(`redirect`, `/family/${this.familyCode}`);
                else
                    localStorage.setItem(`redirect`, `/dashboard`);

                this.$store.dispatch(`login`, {
                    url: `/wifi/client/user/login`,
                    params: {
                        email: this.newUser.email,
                        password: this.newUser.password,
                        mac_address: this.$route.query.mac_address
                    }
                }).then(() => {
                    const user = this.user;
                    let formData = new FormData();
                    for (let key in user) {
                        if (user.hasOwnProperty(key))
                            formData.set(key, user[key]);
                    }

                    this.$emit(`login-finished`);
                    if (this.$route.query.mac_address) {
                        localStorage.setItem(`mac_address`, this.$route.query.mac_address);
                    } else {
                        localStorage.removeItem(`mac_address`);
                    }
                }).catch(() => {
                    this.$swal({
                        icon: `error`,
                        title: this.tr([`Could not login`, `Connexion non valide`]),
                        text: this.tr([`Wrong email or password.`, `Mauvais nom d'utilisateur ou mot de passe`])
                    });
                });
            },
            validateForm() {
                if (this.$refs.email && !this.$refs.email.state) {
                    this.error_msg = this.tr([`Email invalid or already used`, `Email invalide ou déjà utilisée`]);
                    return false;
                }
                if (!this.$refs.password.state) {
                    this.error_msg = this.tr([`Password invalid, need at least 5 characters`, `Mot de passe invalide. Le mot de passe doit contenir au moins 5 caractères`]);
                    return false;
                }
                if (!this.$refs.confirm.state) {
                    this.error_msg = this.tr([`Oops, passwords don't match`, `Oops, les mots de passe sont différents`]);
                    return false;
                }
                if (!this.$refs.firstname.state) {
                    this.error_msg = this.tr([`First name invalid`, `Prénom non valide`]);
                    return false;
                }
                if (!this.$refs.lastname.state) {
                    this.error_msg = this.tr([`Last name invalid`, `Nom non valide`]);
                    return false;
                }
                return true;
            },
            createAccount() {
                if (!this.validateForm())
                    return;
                this.newUser.language = this.tr([`en`, `fr`]);
                this.creationLoading = true;

                if (localStorage.getItem(`utm_source`)) {
                    this.newUser.source = localStorage.getItem(`utm_source`);
                }

                Network.post(`/wifi/client/user/create`, this.newUser)
                    .then(() => {
                        if (this.isFromWifi) {
                            this.$swal({
                                icon: `success`,
                                title: this.tr([`Congratulations!`, `Félicitations !`]),
                                text: this.tr([`You are now going to be redirected to the login page`, `Vous allez maintenant être redirigé vers la page de connexion`])
                            }).then(() => {
                                this.creationLoading = false;
                                window.history.back();
                            });
                        } else {
                            this.$swal({
                                icon: `success`,
                                title: this.tr([`Congratulations!`, `Félicitations !`]),
                                text: this.tr([`You are now going to be redirected to your account`, `Vous allez maintenant être redirigé vers votre compte`])
                            }).then(() => {
                                this.creationLoading = false;
                                this.login();
                            });
                        }
                    })
                    .catch(resp => {
                        this.creationLoading = false;
                        if (resp.data === `error_already_exists`) {
                            this.$swal({
                                icon: `error`,
                                title: this.tr([`Error`, `Erreur`]),
                                text: this.tr([`This email has already been used`, `Cet email est déjà utilisée`])
                            });
                        } else {
                            this.$swal({
                                icon: `error`,
                                title: this.tr([`Error`, `Erreur`]),
                                text: this.tr([`Account creation failure`, `Erreur lors de la création du compte`])
                            });
                        }
                    });
            },
            testEmailAvailability() {
                if (!this.newUser.email || this.newUser.email === ``)
                    return;
                Network.get(`/wifi/client/user/email-available/${this.newUser.email}`)
                    .then(res => {
                        this.emailAvailable = res.data;
                    })
                    .catch(err => {
                        console.error(err);
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../assets/style/welcome-page";
    @import "../assets/style/bootstrap-theme.scss";

    .welcome-header {
        small {
            font-size: 12pt;
            font-weight: 700;
            letter-spacing: 1px;
        }

        h4 {
            font-size: 40pt;
            font-weight: 700;
            margin-bottom: 50px;
        }
    }

    .error-msg {
        display: block;
        text-align: center;
        color: map-get($theme-colors, "danger");
        margin-top: 0.5em;
    }

    #balloon-img {
        display: block;
        margin: 50px auto;
        width: 30%;
        height: 30%;
        user-drag: none;
        user-select: none;
    }

    #registration-form {
        max-width: 500px;
    }

    #welcome-title {
        text-align: center;
        font-size: 20pt;
    }

    #preferences-p {
        text-align: justify;
    }

    #confetti {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
    }

    #preferences-note {
        text-align: justify;
        margin: 20px auto;
        font-size: 10pt;
    }

    .interest-box {
        max-width: calc(100% / 3);
        max-height: calc(100% / 3);
        display: inline-block;
        padding: 0 50px;
        text-align: center;
    }

    .interest-click {
        display: block;
        margin: auto;
        border-radius: 15px;
        -webkit-box-shadow: 6px 7px 23px -2px rgba(189, 183, 189, 1);
        -moz-box-shadow: 6px 7px 23px -2px rgba(189, 183, 189, 1);
        box-shadow: 6px 7px 23px -2px rgba(189, 183, 189, 1);
    }

    .interest-click:hover {
        cursor: pointer;
    }

    .interest-click:hover > img {
        filter: opacity(25%);
    }

    .interest-img {
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        max-width: 100%;
        max-height: 100%;
        margin: auto;
        display: block;
        user-drag: none;
        user-select: none;
        -moz-user-select: none;
        -webkit-user-drag: none;
        -webkit-user-select: none;
        -ms-user-select: none;
    }

    .interest-text {
        background-color: #999999;
        color: white;
        border-bottom-left-radius: 15px;
        border-bottom-right-radius: 15px;
        padding: 5px 0;
    }

    .selected-icon {
        width: 30px;
        height: 30px;
    }

    .icon-box {
        position: absolute;
    }

    .vue-form-wizard::v-deep {
        .wizard-tab-content,
        .wizard-card-footer {
            max-width: 800px;
            margin: 0 auto;
        }
    }

    .title {
        font-size: 2em !important;
    }

    .email-lock {
        margin-top: -40px;
        margin-bottom: 10px;
        border-radius: 10px;
        background-color: map-get($theme-colors, "info");
        color: white;
        max-width: fit-content;
        font-size: 11pt;
        font-weight: 500;
        letter-spacing: 1px;
        height: 38px;
        padding: 0.375rem 0.75rem;
        max-height: fit-content;
        border: 2px solid map-get($theme-colors, "info");
        cursor: default;
    }

    .lock-icon {
        height: 38px;
        font-size: 11pt;
    }

    @media(max-width: 576px) {
        .title {
            font-size: 1.5em !important;
        }
    }
</style>
